/* eslint-disable brace-style */
/* eslint-disable security/detect-object-injection */
import Agent from 'agentkeepalive'
import axios from 'axios'
import { BareFetcher } from 'swr'

import { ServerContext, RequestHeaders } from '@/core/types/interfaces'

import { isServer } from '../utils/environment'

// eslint-disable-next-line import/no-named-as-default-member
const { HttpsAgent } = Agent

const httpAgent = new Agent({
  keepAlive: true,
  maxSockets: 100,
  maxFreeSockets: 10,
  timeout: 60000,
  freeSocketTimeout: 30000,
})

const httpsAgent = new HttpsAgent({
  keepAlive: true,
  maxSockets: 100,
  maxFreeSockets: 10,
  timeout: 60000,
  freeSocketTimeout: 30000,
})

const client = axios.create({
  httpAgent,
  httpsAgent,
})

const processStoreQueryParams = (context) => {
  let queryParams = ''
  const query = context?.req?.query || {}

  if (query['storeId']) {
    queryParams += `&storeId=${query['storeId']}`
  }
  return queryParams
}

export interface HttpClientOptions {
  context?: ServerContext
  requestTraceId: string
  signal?: AbortSignal
  headers?: RequestHeaders
  method?: 'GET' | 'POST'
}

const httpClient = <T>(options?: HttpClientOptions): BareFetcher<T> => {
  const { context, requestTraceId, signal, headers } = options || {}
  const baseUrl = isServer ? process.env.JOKER_URL : window.location.origin || ''

  const buildHeaders = (): RequestHeaders => {
    const baseHeaders: RequestHeaders = {}

    if (context?.req) {
      baseHeaders.cookie = context.req.headers.cookie || ''
    }

    if (requestTraceId) {
      baseHeaders.requestTraceId = requestTraceId
    }

    if (headers) {
      Object.assign(baseHeaders, headers)
    }

    return baseHeaders
  }

  const requestOptions = isServer
    ? {
        headers: buildHeaders(),
        ...(options?.signal ? { signal: options.signal } : {}),
      }
    : {
        withCredentials: true,
        headers: buildHeaders(),
        ...(signal ? { signal } : {}),
      }

  return async (url: string): Promise<T> => {
    const requestUrl = new URL(
      `${url}${processStoreQueryParams(context)}`,
      baseUrl
    ).toString()

    const response = await client.get(requestUrl, requestOptions)
    return response.data
  }
}

export default httpClient
